import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ErrorFallback: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.mode === 'dark' ? '#1a1a1a' : '#ffffff',
        px: 3,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: 4,
          }}
        >
          {/* Insight Analytics Logo */}
          <Box sx={{ mb: 2 }}>
            <img
              src="/insightLongLogoPrimaryWhiteText.svg"
              alt="Insight Analytics Logo"
              style={{
                height: 64,
                width: 'auto',
                maxWidth: '100%',
              }}
            />
          </Box>

          {/* Error Message */}
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: theme.palette.mode === 'dark' ? '#ffffff' : '#1d1d1f',
                mb: 2,
                fontSize: { xs: '1.5rem', md: '2rem' },
              }}
            >
              Something went wrong
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.mode === 'dark' ? '#9ca3af' : '#64748b',
                fontSize: { xs: '0.875rem', md: '1rem' },
                lineHeight: 1.6,
                maxWidth: 400,
                mx: 'auto',
              }}
            >
              We encountered an unexpected error. Try refreshing the page or use
              the sidebar to navigate to another page.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ErrorFallback;
